module.exports = __webpack_public_path__ + "img/YouPlusZH-6.dba72942.jpg";